export const offerCommonDescription = {
  EarningMechanismExternalFulfillment:
    'Offer is used to influence members behavior by allowing an external system (point of sale, pump, etc) be responsible for determining whether or not the offer has been fulfilled. Offer will be considered fulfilled in Activate when the transaction is recorded.',
  EarningMechanismTotalEligiblePurchase:
    'Offer is used to incentivize members to make purchases within a set of product groups.',
  EarningMechanismTotalEligiblePurchaseOverTime:
    'Offer is used to incentivize members to reach a specified cumulative threshold by purchasing products within a set of product groups across multiple transactions.',
  EarningMechanismProductPurchase:
    'Offer is used to influence consumers to buy a particular amount within a set of specific product groups.',
  EarningMechanismTotalSpendOverTime:
    'Offer is used to influence consumers to reach threshold by purchasing almost all products with a small set of configured exclusions with multiple transactions.',
  EarningMechanismVisits:
    'Offer is used to encourage members to visit regularly and make purchases frequently.',
  EarningMechanismLoyaltyEvent:
    'Offer is used to incentivize members to trigger a particular loyalty event.',
  EarningMechanismMembershipEvent:
    'Offer is used to engage members into program based on triggered membership event.',
  EarningMechanismVarietyPurchase:
    'Offer is used to incentivize members to make purchases within a specific combination of products with a single transaction.',
  EarningMechanismVarietyPurchaseOverTime:
    'Offer is used to incentivize members to make purchases within a specific combination of products across multiple transactions.',
  EarningMechanismPointSpend:
    'Offer is used to allow a member to spend their previously-earned points in exchange for vouchers',
  EarningMechanismTransactionDiscount:
    'Offer is used to influence consumers to reach threshold by purchasing more product to get full-transaction discounts',
  EarningMechanismProductDiscount:
    'Offer is used to incentivize members to by buy particular amount of specific products',
  EarningMechanismVarietyDiscount:
    'Offer is used to influence consumers to buy a particular amount within a variety of products',
};
